// Endpoint definitions for Push Blast module.
// Base path: /push-blast. All endpoints require role: ADMIN.

export const E_PUSH_NOTIFICATION = Object.freeze({
  // List all blasts (filter by status, fromDate, toDate, page, limit)
  LISTING: "/push-blast",

  // Drafts collection — used to create/update draft before sending
  LISTING_DRAFTS: "/push-blast/drafts",
  MAIN_DRAFT: (id: string) => `/push-blast/drafts/${id}`,

  // Single blast detail
  MAIN: (id: string) => `/push-blast/${id}`,

  // Actions
  SCHEDULE: (id: string) => `/push-blast/${id}/schedule`,
  SEND: (id: string) => `/push-blast/${id}/send`,
  CANCEL: (id: string) => `/push-blast/${id}/cancel`,
});
